import { Controller } from 'stimulus';

class Header extends Controller {

  initialize() {

    this.headerH  = this.element.offsetHeight;
    // this.alertH   = this.alertTarget.offsetHeight;
    this.getHeights();
 
    // if($('body.home').length) {
    // we may need detect if it is a certain template 
    // to already include .add-bg class
    this.scroll = window.addEventListener('scroll', this.checkPosition.bind(this), false);
    this.resize = window.addEventListener('resize', this.checkPosition.bind(this), false);
    // }
  }

  checkPosition() {
    const pageHeader = this.element;
    if (window.scrollY > this.element.offsetHeight) {
      pageHeader.classList.add('add-bg');
    } else {
      pageHeader.classList.remove('add-bg');
    }
  }

  getHeights() {
    this.headerH = this.element.offsetHeight;
    document.body.style.setProperty('--header-height', this.headerH + 'px');
  }

  toggleNav() {
    const main = document.getElementById('main');
    this.togglerTarget.classList.toggle('is-active');
    if (this.hasOverflowTarget) {
      this.element.classList.toggle('show-bg');
      this.overflowTarget.classList.toggle('invisible');
      this.overflowTarget.classList.toggle('visible');
      this.overflowTarget.classList.toggle('opacity-0');
      this.overflowTarget.classList.toggle('opacity-100');
      main.classList.toggle('overlay');
    }
    document.body.classList.toggle('lock-body-for-mobile-menu');
  }

  toggleSearch(e) {
    e.preventDefault()
    if (!document.body.classList.contains('search')) this.searchButtonTarget.classList.toggle('active');
  }

}

Header.targets = ['toggler', 'alert', 'header', 'main', 'overflow', 'searchButton', 'searchModal', 'searchInput'];

export default Header;
